<template>
	<transition name="modal-fade">
		<div class="modal-backdrop">
			<div class="modal">
				<form action="#" @submit.prevent="updateProfile">
					<h3 class="text-center text-lg font-bold">{{ $t("homepage_email_modal_title") }}</h3>
					<p class="text-center">{{ $t("homepage_email_modal_desc") }}</p>
					<div class="mb-5 relative">
						<input
							type="email"
							class="w-full border-b-2 p-3 pl-12"
							placeholder="Your Email"
						/>
						<img
							class="absolute bottom-4 left-3"
							src="../assets/images/icon_mail.svg"
							alt=""
						/>
					</div>
					<div class="flex gap-4 pl-2 justify-center">
						<button type="submit" class="bg-green-2 py-2 block w-full rounded-xl font-bold text-white">{{ $t("setting_update") }}</button>
					</div>
				</form>

			</div>
		</div>
	</transition>
</template>

<script>
import AudioComponent from '@/components/AudioComponent.vue'

  export default {
    name: 'ModalPages',
	components: {
		AudioComponent,
	},
	mounted() {
		this.$store.commit('SET_GAME_BACKSOUND', false)
	},
    methods: {
		updateProfile (event) {
			this.$emit('updateProfile', event.target[0].value)
		},
    }
  }
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
	border-radius: 10px;
	padding: 20px;
	margin: 0 20px;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
}
</style>